module.exports = __webpack_public_path__ + "media/img/apple-icon-180x180-f81b4358b45eb6b709a2b154dca00fc8.png";